import { EjHolidaysConfig } from 'server-schemas/configs';
let config: EjHolidaysConfig = {
  contentPaths: {
    en: ''
  },
  sandbox: ''
};

export const set = (t: EjHolidaysConfig) => {
  config = t;
};

export const get = () => {
  return config;
};
